import $ from "jquery";
import _ from "lodash";
import { setDirtyEditPinsFlagReduxStateAction } from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import { store } from "redux/store";
import { greenImageSize } from "./constants";
import { createPin } from "./createPins";
import {
  activeRotation,
  removeSelectedPinMarker,
  selectElement,
  deselectElement,
  setAttributes,
  logAction,
  updatePin,
  updateElements,
  addClassSvg,
  removeClassSvg,
} from "./helpers";

export function pinsEditButtonMode(hole) {
  let pins;
  let state = store.getState();
  let pinsEditModeReduxState = state.commonReducers.pinsEditModeReduxState;
  function handleMouseDown (e) {
      selectElement(e, hole)
  }
  function handleMouseUp(e) {
    deselectElement(e, hole)
  }
  let active = activeRotation();
  let activeMarker =
    active !== null && Object.keys(active).length !== 0
      ? active.Marker
      : "cog";
  function mousedownFunction(evt) {
    // check that we don't have a pin selected
    if (evt.target.nodeName !== "circle") {
      // look for active pin.
      var svg = evt.target.ownerSVGElement
      if (svg !== null) {
        var pinList = svg && svg.getByClass("pin");
        _.forEach(pinList, function (pin) {
          var marker = pin.getAttribute("data-marker");
          if (marker === activeMarker) {
            // move the pin
            store.dispatch(setDirtyEditPinsFlagReduxStateAction(true));
            svg.removeChild(pin);
            pin = createPin(
              {
                Name: marker,
                Latitude: 0,
                Longitude: 0,
                X: evt.offsetX,
                Y: evt.offsetY,
              },
              null,
              svg
            );
            pin.addEventListener(
              "mousedown",
              function () {
                selectElement(evt, hole)
              },
              false
            );
            updatePin(pin, hole);
            updateElements(svg, hole);
            logAction("Move pins");
          }
        });
      }
    }
  }
  if (pinsEditModeReduxState) {
    // For Showing Pins by clicking edit button
    $(".pinsDisplay, .outsideWrapper")
      .width(greenImageSize + 40)
      .get()
      .forEach(function (elem) {
        setAttributes(elem, { width: greenImageSize + 40 });
      });

    //Attach listener
    $('.pinsDisplay .pin').on('mousedown', handleMouseDown);
    $(".pinsDisplay .pin").on('touchstart',handleMouseDown);
    $('.pinsDisplay .pin').on('mouseup', handleMouseUp);
    $(".pinsDisplay").on("mousedown", mousedownFunction);
    pins = document.getElementsByClassName("pin");
    _(pins).forEach(function (el) {
      addClassSvg(el, "draggable");
    });
    $(".thumbnail").addClass("pinsEditMode");
  } else {
    $(".thumbnail").removeClass("pinsEditMode");
    $(".pinsDisplay, .outsideWrapper")
      .width(greenImageSize)
      .get()
      .forEach(function (elem) {
        setAttributes(elem, { width: greenImageSize });
      });
    // Delete selectedPin
    removeSelectedPinMarker();
    // Remove listener
    $('.pinsDisplay .pin').off('mouseup', handleMouseUp);
    $('.pinsDisplay .pin').off('mousedown',handleMouseDown);
    $(".pinsDisplay .pin").off('touchstart',handleMouseDown);
    $('.pinsDisplay').off('mousedown',mousedownFunction);
    pins = document.getElementsByClassName("pin");
    _(pins).forEach(function (el) { removeClassSvg(el, "draggable"); });
  }
}
